import { createAction } from '@poa/state';

// fetching
export const fetchUser = createAction('fetchUser', (id, variant) => ({ id, variant }));
export const fetchUserSuccess = createAction('fetchUserSuccess', data => ({ data }));
export const fetchUserFailed = createAction('fetchUserFailed', () => ({}));

// creating
export const createUser = createAction('createUser', (user, variant) => ({ user, variant }));
export const createUserSuccess = createAction('createSuccess', user => ({ user }));
export const createUserFailed = createAction('createFailed', () => ({}));

// updating
export const updateUser = createAction('updateUser', (user, variant) => ({ user, variant }));
export const updateUserSuccess = createAction('updateSuccess', user => ({ user }));
export const updateUserFailed = createAction('updateFailed', () => ({}));
